/**
 * @Author: 陈瑞鹏
 * @Date:   2022-09-07 13:52:44
 * @Last Modified by:   陈瑞鹏
 * @Last Modified time: 2022-09-09 13:54:21
 */

const userIndex = r => require.ensure([], () => r(require('VIEWS/admin/user/index.vue')), 'userIndex')
const sbIndex = r => require.ensure([], () => r(require('VIEWS/admin/sb/index.vue')), 'sbIndex')
const sbInfo = r => require.ensure([], () => r(require('VIEWS/admin/sb/info.vue')), 'sbInfo')
const musicIndex = r => require.ensure([], () => r(require('VIEWS/admin/music/index.vue')), 'musicIndex')
const musicEdit = r => require.ensure([], () => r(require('VIEWS/admin/music/edit.vue')), 'musicEdit')

export default [{
        path: '*',
        redirect: '/admin/user/index'
    },
    {
        path: '/admin/user/index',
        name: 'userIndex',
        component: userIndex,
        meta: {
            requireAuth: true
        }
    },
    {
        path: '/admin/sb/index',
        name: 'sbIndex',
        component: sbIndex,
        meta: {
            requireAuth: true
        }
    },
    {
        path: '/admin/sb/index',
        name: 'sbInfo',
        component: sbInfo,
        meta: {
            requireAuth: true
        }
    },
    {
        path: '/admin/music/index',
        name: 'musicIndex',
        component: musicIndex,
        meta: {
            requireAuth: true
        }
    },
    {
        path: '/admin/music/edit',
        name: 'musicEdit',
        component: musicEdit,
        meta: {
            requireAuth: true
        }
    }
]


// WEBPACK FOOTER //
// ./src/router/modules/admin.js